// Dayjs

import Vue from 'vue/dist/vue.esm';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/cs';
import 'dayjs/locale/en-gb';

dayjs.extend(localizedFormat);
dayjs.extend(isBetween);

const lang = document.documentElement.lang
let locale

switch(lang) {
  case 'en':
    locale = 'en-gb';
    break;
  case 'cs':
    locale = 'cs';
    break;
}
dayjs.locale(locale)

Object.defineProperties(Vue.prototype, {
  $date: {
    get() {
      return dayjs
    }
  }
});
